import { render, staticRenderFns } from "./roomWiseAbsentList.vue?vue&type=template&id=be400530&scoped=true&"
import script from "./roomWiseAbsentList.vue?vue&type=script&lang=js&"
export * from "./roomWiseAbsentList.vue?vue&type=script&lang=js&"
import style0 from "./roomWiseAbsentList.vue?vue&type=style&index=0&id=be400530&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be400530",
  null
  
)

export default component.exports